import { useNavigate } from "@tanstack/react-router";

import { useTour } from "../../components/onboarding/tourContext";
import { Button } from "../../components/ui/button";

// Settings "Getting started" section (L0-U10 session 2). The re-launchable home
// for the product tour and demo mode — both are otherwise one-shot affordances
// surfaced by the first-run wizard / dashboard card. Starting the tour here
// works because Settings renders inside the AppShell, which is wrapped by the
// TourProvider.
export function GettingStartedSection() {
  const navigate = useNavigate();
  const { startTour } = useTour();

  return (
    <section aria-labelledby="getting-started-heading" className="space-y-6">
      <header>
        <h2
          id="getting-started-heading"
          className="font-display text-xl font-medium tracking-tight text-on-surface"
        >
          Getting started
        </h2>
        <p className="mt-1 text-sm text-on-surface-variant">
          Re-run the product tour or explore a sample journal any time.
        </p>
      </header>

      <div className="space-y-4">
        <div className="flex flex-wrap items-center justify-between gap-3 rounded-card border border-outline-variant bg-surface-container p-4">
          <div className="min-w-0">
            <p className="font-medium text-on-surface">Product tour</p>
            <p className="mt-0.5 text-sm text-on-surface-variant">
              A guided walkthrough of the main surfaces.
            </p>
          </div>
          <Button
            type="button"
            onClick={() => {
              startTour();
            }}
          >
            Take a tour
          </Button>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-3 rounded-card border border-outline-variant bg-surface-container p-4">
          <div className="min-w-0">
            <p className="font-medium text-on-surface">Demo data</p>
            <p className="mt-0.5 text-sm text-on-surface-variant">
              See a populated journal with sample trades. Nothing is written to
              your account.
            </p>
          </div>
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              void navigate({ to: "/demo" });
            }}
          >
            View demo
          </Button>
        </div>
      </div>
    </section>
  );
}
